import { Box, List } from "@mui/material";
import ChannelButton from "./ChannelButton";

const Sidebar = ({
  channels,
  selectedChannel,
  handleChannelClick,
  notifications,
  isMobileDisplay,
  sidebarWidth,
}) => {
  if (!selectedChannel) return null;
  return (
    <Box
      className="hub-sidebar-container"
      sx={{
        width: isMobileDisplay ? "100%" : sidebarWidth,
        flexDirection: isMobileDisplay ? "row" : "column",
        borderRadius: isMobileDisplay ? "0 0 0.75rem 0.75rem" : "0.75rem 0 0 0.75rem",
      }}
    >
      <List
        sx={{
          display: "flex",
          flexDirection: isMobileDisplay ? "row" : "column",
          width: "100%",
        }}
      >
        {channels.map((channel) => (
          <ChannelButton
            key={channel.key}
            channel={channel}
            selectedChannel={selectedChannel}
            clickHandler={handleChannelClick}
            disabled={channel.disabled}
            notifications={notifications[channel.notificationKey]}
          />
        ))}
      </List>
    </Box>
  );
};

export default Sidebar;
